export const MEALS_AND_ENTERTAINMENT_MESSAGE = `If you’re expensing a business meal, be sure to include everyone that attended that meal.`;
